const GetCustomerType = {
  IS_GET_ALL: 1,
  GET_MY_CUSTOMER: 2
}
export default GetCustomerType
